// extracted by mini-css-extract-plugin
module.exports = {"SmallerIcon":"ContextMenu_SmallerIcon__u_0de"};